import {MutationTree} from "vuex";
import DataVariableInterface from "../../DataVariables/ts/DataVariableInterface";
import Panelist from "../ts/PanelistInterface";
import Filter from "../../ProjectManager/ts/Filter";

export const mutations: MutationTree<any> = {

    setPanelistsLoading(state: any, payload: boolean) {
        state.panelistsLoading = payload;
    },

    setPanelists(state: any, payload: any) {
        state.panelists = payload;
    },

    updatePanelistsDataVariableByIds(state: any, payload: any) {
        // Loop thru all the panelists
        payload.ids.forEach((panelistId: string) => {
            let panelist = state.panelists.find((panelist: Panelist) => panelist.panelist_id === panelistId);

            // If panelist is located in the search or list screen
            if (panelist) {
                panelist.data_variables[payload.dataVariableId] = payload.value;
            }
        });
    },

    updateAllPanelistsDataVariable(state: any, payload: any) {
        state.panelists.forEach((panelist: Panelist) => {
            panelist.data_variables[payload.dataVariableId] = payload.value;
        });
    },

    deleteProfileFromSearchResults(state: any, panelistId: string) {
        const index = state.panelists.findIndex((panelist: Panelist) => {
            return panelist.panelist_id === panelistId;
        });

        if (index === -1) throw new Error('Could not find panelist ' + panelistId + ' to delete!');
        state.panelists.splice(index, 1);

        state.meta = {
            available: state.meta.available - 1,
            executionTime: state.meta.executionTime,
        }
    },

    clearSearchResults(state: any) {
        state.panelists = [];
        state.meta = {
            available: 0,
            executionTime: 0
        }
    },

    setMeta(state: any, payload: any) {
        state.meta = payload;
    },

    setSearchActive(state: any, payload: any) {
        state.searchActive = payload;
    },

    clearMeta(state: any, payload: any) {
        state.meta.executionTime = 0;
        state.meta.available = 0;
    },

    updateSearch(state: any, payload: string) {
        state.search = payload;
    },

    setSelectedVariables(state: any, payload: Array<any>) {
        state.selectedVariables = payload;
        state.selectedVariableIds = payload.map((dataVariable: DataVariableInterface) => dataVariable.uuid);
        state.search.ids = state.selectedVariableIds;
    },

    setSelectedRows(state: any, payload: any) {
        state.selectedRows = payload;
    },

    setHeaders(state: any, payload: any) {
        state.headers = payload;
    },

    setItemsPerPage(state: any, payload: any) {
        state.itemsPerPage = payload;
    },

    setProfileLoading(state: any, payload: boolean) {
        state.profileLoading = payload;
    },

    setProfile(state: any, payload: any) {
        state.profile = payload;
    },

    setActivityTableSettings(state: any, payload: any) {
        state.activityTableSettings = payload;
    },

    setRewardsTableSettings(state: any, payload: any) {
        state.rewardsTableSettings = payload;
    },

    setRedemptionTableSettings(state: any, payload: any) {
        state.redemptionsTableSettings = payload;
    },

    setVariablesEditableOnly(state: any, payload: any) {
        state.variablesEditableOnly = payload;
    },

    setVariablesSearchTerm(state: any, payload: any) {
        state.variablesSearchTerm = payload;
    },

    setVariablesFilterModel(state: any, payload: any) {
        state.variablesFilterModel = payload;
    },

    setTimeLineFilters(state: any, payload: any) {
        state.timeLineFilters = payload;
    },

    clearEditState(state: any) {
        state.profile = {};
    },

    setFilters(state: any, payload: any) {
        state.filters = JSON.parse(JSON.stringify(payload));
    },

    clearActiveFilters(state: any) {
        state.filters.forEach((filter: Filter) => filter.model = false);
    }
};
